// import { API_BASE_URL, BEARER_TOKEN, BEARER_TOKEN_V2 } from './apiConfig';
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || '';
const BEARER_TOKEN_V2 = process.env.REACT_APP_BEARER_TOKEN_V2 || '';

export interface SettingList {
  id: string;
  app_name: string;
  created_at: string;
  app_type: string;
  organization_id: string;
  deleted_by: string | null;
  last_updated_at: string | null;
  align_chat_button: string;
  auto_open_chat_window_after: number;
  button_color: string;
  display_name: string;
  footer_color: string;
  header_color: string;
  image_url: string;
  is_deleted: boolean;
  is_only_allowed_on_domains: boolean;
  is_public: boolean;
  is_security_question_required: boolean;
  limite_mensajes: number;
  messages_rate_limit: number;
  show_document_references: boolean;
  theme: string;
  time_limit: number;
  use_conversation_history: boolean;
  user_message_color: string;
  is_voice_enabled: boolean;
}

export const getSettings = async (
	id: string,
): Promise<SettingList> => {
	const apiUrl = `${API_BASE_URL}/v2/applications/${id}`;
	try {
		const requestOptions: RequestInit = {
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
				Bearer: BEARER_TOKEN_V2,
			},
		};

		const response = await fetch(apiUrl, requestOptions);
		const data: SettingList = await response.json();

		if (!response.ok) {
			throw new Error(`HTTP error! Status: ${response.status}`);
		}
		return data;
	} catch (error) {
		console.error('Error fetching chatbot settings:', error);
		throw error;
	}
};

export default getSettings;